import { ComingSoonTag, UserSimpleInfo } from '@aibees/shared/components';
import {
  memberStatusColorMap,
  StatusTag,
} from '@aibees/shared/components/status-tag';
import { Member, MemberStatus, MemberType } from '@aibees/shared/definition';
import { AdvanceTableConfig } from '@aibees/shared/features';
import type { BrowseApi } from '@aibees/shared/features/advance-table/types';
import { Typography } from '@mui/material';
import { capitalize } from 'lodash-es';
import { useBrowseTeamMembersApi } from '../../hooks/use-browse-team-members-api';
import { TeamMemberEditAction } from './actions/team-member-edit-action';
import { StyledInactiveMember } from './styles';
import { TeamMemberJoined } from './team-member-joined';

export const config: AdvanceTableConfig<Member> = {
  browseApi: useBrowseTeamMembersApi as unknown as BrowseApi<any>,
  rowKey: 'user.id',
  columns: [
    {
      id: 'user',
      key: 'avatar',
      label: 'Team Member',
      render: (_, v) => (
        <StyledInactiveMember inactive={v.status === MemberStatus.disable}>
          <UserSimpleInfo user={v.user} isOwner={v.type === MemberType.Owner} />
        </StyledInactiveMember>
      ),
      width: '25%',
    },
    {
      id: 'type',
      key: 'role',
      label: 'Role',
      width: '10%',
      render: (_, v) => (
        <StyledInactiveMember inactive={v.status === MemberStatus.disable}>
          <Typography variant="body3" fontWeight={400} color="grey.700">
            {capitalize(v.type)}
          </Typography>
        </StyledInactiveMember>
      ),
    },
    {
      id: 'status',
      key: 'status',
      label: 'Status',
      width: '10%',
      sortable: 'status',
      render: (v) => (
        <StatusTag
          status={v}
          label={capitalize(v === MemberStatus.disable ? 'Disabled' : v)}
          colorMap={memberStatusColorMap}
          key={v}
          fullWidth
        />
      ),
    },
    {
      id: 'created',
      key: 'created',
      label: 'Joined',
      width: '45%',
      sortable: 'created',
      render: (_, v) => (
        <StyledInactiveMember inactive={v.status === MemberStatus.disable}>
          <TeamMemberJoined item={v} />
        </StyledInactiveMember>
      ),
    },
    {
      key: 'creditCap',
      label: 'Credit Cap',
      align: 'center',
      width: '20%',
      render: (_, v) => <ComingSoonTag size="small" />,
    },
  ],
  actions: [TeamMemberEditAction],
  filters: [],
  styles: {
    roundedHeader: true,
  },
  actionsConfig: {
    label: 'Action',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  bordered: 'solid',
  showJumpToPage: true,
  hidePagination: false,
  rowsPerPageOptions: [10, 20, 50],
  defaultOrderBy: 'status',
};
